import genererPanneau, { genererBudget } from '@/services/gestionPanneau/genererPanneau';
import { CATEGORIE_FORFAIT_AUDIT } from '@/configuration/configPanneau';

export function genererPanneauHonoraireForfaitaire(montant) {
  const panneau = genererPanneau();
  panneau.categorie = {
    libelle: CATEGORIE_FORFAIT_AUDIT,
    couleur: '#999999',
    tags: ['FORFAIT', 'AUDIT'],
  };
  const budget = genererBudget();
  budget.honoraires = montant;
  budget.prixTotal = montant;
  panneau.budgets = [budget];
  return panneau;
}
